export function capturePairingScope(options: { matchProfile?: boolean } = {}) {
  const { matchProfile = true } = options;
  const read = () => {
    let accountId: string | null = null;
    try { accountId = JSON.parse(localStorage.getItem('yada:account:account') || 'null')?.id ?? null; } catch { /* invalid account cannot match later */ }
    return {
      accountId,
      profileId: localStorage.getItem('yada:account:activeProfileId'),
      deviceId: localStorage.getItem('yada:deviceId'),
    };
  };
  const original = read();
  return () => {
    const current = read();
    if (current.accountId !== original.accountId || current.deviceId !== original.deviceId) return false;
    if (matchProfile && original.profileId !== null && current.profileId !== null && current.profileId !== original.profileId) return false;
    return true;
  };
}

export function pairingErrorMessage(error: unknown): string {
  const failure = error as { message?: string; receipt?: { totalWorkspaces: number; syncedWorkspaces: number; keyReadyWorkspaces: number } };
  const progress = failure?.receipt;
  const reason = failure?.message || 'Device setup failed. Keep both devices open and retry.';
  return progress ? `${progress.keyReadyWorkspaces}/${progress.totalWorkspaces} workspace keys available; ${progress.syncedWorkspaces}/${progress.totalWorkspaces} workspaces synced. ${reason}` : reason;
}
